<script>
const models = window.models

import { selection, activeStep } from './lib.js';

</script>
<h2 class="byo-heading -interior">Choose Your Floor Plan</h2>

<div class="byo-card">
    {#each $selection.floorplans as floorplan}
        <button on:click={() => { $selection.chosenFloorplan = floorplan}} class="byo-card__item {$selection.chosenFloorplan == floorplan ? 'selected' : ''}">
            <div class="byo-card__content">
                <div class="byo-card__content-wrapper">
                    <img src="{ floorplan.image }" alt="" class="byo-card__floorplan-image">
                    <div class="byo-card__text-content js-const-height">
                        <div class="byo-card__header -split">
                            <h2 class="byo-card__content-heading">{ floorplan.name }</h2>
                        </div>
                        <div class="byo-card__content-desc model-preview__content-rte">
                            {@html floorplan.summary || '' }
                        </div>
                    </div>
                </div>
            </div>
        </button>

    {/each}
</div>

<div class="continue-bar js-continue-bar -active">
    <button class="continue-bar__text button -back js-forward" on:click="{() => { $activeStep = 1; window.scrollTo(0,0);}}">Prev</button>
    <button disabled={!$selection.chosenFloorplan} class="continue-bar__text button -forward js-forward" on:click="{() => { $activeStep = 3; window.scrollTo(0,0);}}">Next</button>
</div>

<style>
.exterior {
    max-width: 1200px;
    height: auto;
    margin: 0 auto;
    display: block;
}

.model-slider__button.-byo.selected::after {
	font-family: icomoon;
	font-size: 1rem !important;
	font-weight: 400;
	line-height: 0;
	font-style: normal;
	content: "";
	display: inline-block;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	width: 2rem;
	height: 2rem;
	background: #0b0b0b;
	border-radius: 50%;
	bottom: 0;
	color: #fff;
	line-height: 2em;
	position: absolute;
	right: -.5rem;
    top: auto;
}

.model-slider__button {
    box-sizing: content-box;
    padding: 0;
    outline: 0;
}

.model-slider__gen-item button {
    background: #fff !important;
    color: #000 !important;

    &.-is-active {
        background: #000 !important;
        color: #fff !important;
    }
}

</style>
